// Where the menu comes from.
//
//   "api"  — FudiTap guest menu API (GET {REACT_APP_FUDITAP_API_BASE}/api/guest/menu?card=CODE).
//   "mock" — the bundled demo restaurant (src/data/*). Development/test ONLY.
//
// A production build is always "api": the demo menu can never be shown to a real
// guest, not even as a silent fallback when the API fails.
export const MENU_SOURCES = { API: "api", MOCK: "mock" };

export function menuSourceMode(env = process.env) {
  if (env.NODE_ENV === "production") return MENU_SOURCES.API;
  return env.REACT_APP_MENU_SOURCE === MENU_SOURCES.API ? MENU_SOURCES.API : MENU_SOURCES.MOCK;
}

export const isApiMenuSource = (env = process.env) => menuSourceMode(env) === MENU_SOURCES.API;

// Origin of the FudiTap panel API (no trailing slash). Empty = same origin.
export function guestMenuApiBase(env = process.env) {
  return String(env.REACT_APP_FUDITAP_API_BASE || "").replace(/\/+$/, "");
}
